import { type QueryObserverOptions, useQuery } from '@tanstack/react-query';
import { sdd_collections_orchestrator as sddCollectionsOrchestrator } from '@repo/domain-types/transfers';
import { apiBaseURL } from 'receivable-invoices-js/constants/hosts';
import { qontoClient } from 'receivable-invoices-js/react/utils/api-clients/qonto';

const apiVersion = 'v1';
const sddCollectionsOrchestratorApi = sddCollectionsOrchestrator.mandates.firstparty.v1;

type ApiGetMandatesInvitationDataRequest =
  sddCollectionsOrchestrator.mandates.firstparty.v1.ApiGetSharedInvitationLinkRequest;
type ApiGetMandatesInvitationDataResponse =
  sddCollectionsOrchestrator.mandates.firstparty.v1.ApiGetSharedInvitationLinkResponse;

export function useFetchMandatesInvitationData(
  params: ApiGetMandatesInvitationDataRequest,
  queryOptions?: Partial<QueryObserverOptions<FetchMandatesInvitationDataResponse>>
) {
  return useQuery({
    queryKey: ['mandates-invitation-data', params.invitationLinkId],
    queryFn: () => fetchMandatesInvitationData(params),
    ...queryOptions,
  });
}

const URL = `${apiBaseURL}/${apiVersion}/direct_debit_collection_invitation_links/shared`;

export async function fetchMandatesInvitationData(
  params: ApiGetMandatesInvitationDataRequest
): Promise<ApiGetMandatesInvitationDataResponse> {
  const response = await qontoClient(`${URL}/${params.invitationLinkId}`);

  return sddCollectionsOrchestratorApi.ApiGetSharedInvitationLinkResponse.fromJSON(response);
}

export type FetchMandatesInvitationDataResponse = Awaited<
  ReturnType<typeof fetchMandatesInvitationData>
>;
